<rask-kundorderrad-create
    [rootForm]="form"
    [kundorder]="order"
    [enableCommands]="false"
    [kundorderTyp]="order.kundordertyp"
    (modelCreated)="onModelCreated($event)">
</rask-kundorderrad-create>

<div class="buttons">
    <rask-save-button [disabled]="!canAdd()" (click)="add()"></rask-save-button>
    <rask-button color="secondary" (click)="dismiss()">Avbryt</rask-button>
</div>
